import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { WelcomeModal } from "@/components/WelcomeModal";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { VisionMission } from "@/components/VisionMission";
import { Services } from "@/components/Services";
import { MarqueeBand, Stats } from "@/components/MarqueeBand";
import { ConceptGallery } from "@/components/ConceptGallery";
import { JournalPreview } from "@/components/JournalPreview";
import { CaseStudiesPreview } from "@/components/CaseStudiesPreview";
import { Testimonials } from "@/components/Testimonials";
import { Enquiry } from "@/components/Enquiry";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [showModal, setShowModal] = useState(false);
  const [ready, setReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const seen = sessionStorage.getItem("aurelume_welcomed");
    if (seen) {
      setReady(true);
    } else {
      setShowModal(true);
      document.body.style.overflow = "hidden";
    }
  }, []);

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target && ready) {
      setTimeout(() => {
        document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }, [location.state, ready]);

  const closeModal = () => {
    sessionStorage.setItem("aurelume_welcomed", "1");
    document.body.style.overflow = "";
    setShowModal(false);
    setReady(true);
  };

  return (
    <main className="bg-[#FDFBF7]">
      <WelcomeModal open={showModal} onClose={closeModal} />
      <Navbar ready={ready} />
      <Hero ready={ready} />
      <Manifesto />
      <VisionMission />
      <Services />
      <MarqueeBand />
      <Stats />
      <ConceptGallery />
      <JournalPreview />
      <CaseStudiesPreview />
      <Testimonials />
      <Enquiry />
      <Footer />
    </main>
  );
}
